import styled from "styled-components";

export const FormControl = styled.div`
    border: 0 !important; // if set to as fieldset, remove the default border
    position: relative;
    width: 100%;
`;
